import React from 'react';
import Avatar from '../Shared/Avatar';



/**
 * TypingIndicator Component
 * Shows animated dots when someone is typing
 *
 * @param {Object} props
 * @param {Object} props.user - User who is typing (optional, for avatar)
 * @param {boolean} props.showAvatar - Whether to show user avatar
 */
const TypingIndicator = ({ user, showAvatar = false }) => {
  return (
    <div className="talk-typing-indicator">
      {showAvatar && user && (
        <Avatar
          src={user.avatar}
          name={user.name}
          size={32}
          className="talk-typing-avatar"
        />
      )}

      <div className="talk-typing-bubble">
        <div className="talk-typing-dots">
          <span className="talk-typing-dot"></span>
          <span className="talk-typing-dot"></span>
          <span className="talk-typing-dot"></span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
